const DIALOG_WIDTH = 310;

export default theme => ({

  dialogRoot: {
    minWidth: DIALOG_WIDTH,
  },

  dialogActions: {
    display: 'flex',
    'justify-content': 'space-between'
  },

  dialog: {
    width: DIALOG_WIDTH,
    height: 420,

    '&:first-child': {
      padding: 0,
    }
  }

});




// WEBPACK FOOTER //
// ./src/shared/styles/components/DatepickerModal.js